import styled from 'styled-components';

export const Wrapper = styled.div`
  background: currentColor;
  height: 0;
  position: relative;
  width: 100%;
`;

export const Video = styled.video`
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
`;
